import React, { ReactNode } from 'react'

type PendingReviewBannerProps = {
  children: ReactNode
  className?: string
}

export const PendingReviewBanner: React.FC<PendingReviewBannerProps> = ({ children, className = '' }) => {
  return (
    <div className={`overflow-hidden rounded-xl border border-amber-100 bg-[#FFF8E1] ${className}`}>
      <div className="border-l-4 border-[#D17D44] px-4 py-4 sm:px-5 sm:py-4">{children}</div>
    </div>
  )
}
